<template>
  <div class="main_box">
    <div class="main_bar">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span class="currentSpan">投票配置</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div></div>
    </div>
    <div
      class="main_body"
      v-loading="loading"
      :element-loading-text="$config.loadingText"
      :element-loading-spinner="$config.loadingSpinner"
      :element-loading-background="$config.loadingBackground"
    >
      <div class="form_bar">
        <div class="form_bar_search"></div>
        <div class="form_bar_btn">
          <el-button type="text" @click="goBack()">返回投票列表</el-button>
          <el-button
            type="primary"
            @click="editVoteSettingAndUpload('settingForm')"
            size="small"
            plain
            v-if="voteInfo.VoteType === 3 && meetingInfo.MeetingType === 0"
          >
            保存
          </el-button>
          <el-button
            type="primary"
            @click="editVoteSetting('settingForm', false)"
            size="small"
            plain
            v-if="voteInfo.VoteType !== 3"
          >
            保存
          </el-button>
          <!-- <el-button
            type="warning"
            size="small"
            @click="editVoteSetting('settingForm', true)"
          >
            完成
          </el-button> -->
        </div>
      </div>
      <div class="form_content">
        <el-form
          :model="settingForm"
          :rules="settingFormRules"
          ref="settingForm"
          class="demo-ruleForm"
          size="mini"
          :label-position="is_xs ? 'top' : 'right'"
        >
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType !== 5"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="是否显示待评项目提示："
                label-width="200px"
                prop="IsShowProjectTitle"
                required
              >
                <el-switch v-model="settingForm.IsShowProjectTitle"></el-switch>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
            >
              <el-form-item
                label="投票列表中待评项目提示："
                label-width="200px"
                prop="VoterTitle"
              >
                <el-autocomplete
                  class="inline-input"
                  v-model="settingForm.ProjectTitle"
                  :fetch-suggestions="queryProjectTitleSearch"
                  placeholder="请输入列表中待评项目提示"
                  @select="projectTitleHandleSelect"
                  :disabled="!settingForm.IsShowProjectTitle"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType !== 5"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="是否显示投票人员提示："
                label-width="200px"
                prop="IsShowVoterTitle"
                required
              >
                <el-switch v-model="settingForm.IsShowVoterTitle"></el-switch>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
            >
              <el-form-item
                label="投票列表中投票人员提示："
                label-width="200px"
                prop="VoterTitle"
              >
                <!-- <el-input
                  v-model="settingForm.VoterTitle"
                  autocomplete="off"
                  placeholder="请输入列表中投票人员提示"
                ></el-input> -->
                <el-autocomplete
                  class="inline-input"
                  v-model="settingForm.VoterTitle"
                  :fetch-suggestions="queryVoterTitleSearch"
                  placeholder="投票列表中投票人员提示"
                  @select="voterTitleHandleSelect"
                  :disabled="!settingForm.IsShowVoterTitle"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType === 0 && meetingInfo.MeetingType === 2"
          >
            <el-col :span="24">
              <el-form-item
                class="el-form-item-internal"
                v-for="(button, buttonIndex) in settingForm.VoteButtonSetting"
                :key="buttonIndex"
              >
                <el-col
                  :xs="{ span: 24 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 11 }"
                  :lg="{ span: 11 }"
                  :xl="{ span: 11 }"
                >
                  <el-form-item
                    label="投票按钮文本："
                    label-width="200px"
                    :prop="'VoteButtonSetting.' + buttonIndex + '.value'"
                    :rules="{
                      required: true,
                      message: '投票按钮文本不能为空',
                      trigger: 'blur'
                    }"
                  >
                    <el-input
                      v-model="button.value"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 24 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 11, offset: 2 }"
                  :lg="{ span: 11, offset: 2 }"
                  :xl="{ span: 11, offset: 2 }"
                >
                  <el-form-item
                    label="是否验证投票数目："
                    label-width="200px"
                    prop="isCheckMaxMin"
                  >
                    <el-switch v-model="button.isCheckMaxMin"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 24 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 11 }"
                  :lg="{ span: 11 }"
                  :xl="{ span: 11 }"
                >
                  <el-form-item
                    label="最大票数："
                    label-width="200px"
                    prop="maxNum"
                  >
                    <el-input-number
                      v-model="button.maxNum"
                      :step="1"
                      :prop="'VoteButtonSetting.' + buttonIndex + '.maxNum'"
                      :rules="{
                        required: true,
                        message: '最大票数不能为空',
                        trigger: 'blur'
                      }"
                      :disabled="!button.isCheckMaxMin"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 24 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 11, offset: 2 }"
                  :lg="{ span: 11, offset: 2 }"
                  :xl="{ span: 11, offset: 2 }"
                >
                  <el-form-item
                    label="最小票数："
                    label-width="200px"
                    prop="minNum"
                  >
                    <el-input-number
                      v-model="button.minNum"
                      :step="1"
                      :prop="'VoteButtonSetting.' + buttonIndex + '.minNum'"
                      :rules="{
                        required: true,
                        message: '最小票数不能为空',
                        trigger: 'blur'
                      }"
                      :disabled="!button.isCheckMaxMin"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-col
            :span="24"
            v-if="voteInfo.VoteType === 0 && meetingInfo.MeetingType === 0"
          >
            <el-divider content-position="left">投票按钮配置</el-divider>
          </el-col>
          <el-row>
            <el-col
              :span="24"
              style="padding: 10px 30px"
              v-if="voteInfo.VoteType === 0 && meetingInfo.MeetingType === 0"
            >
              <el-button type="primary" @click="addBtn()"> 新增按钮 </el-button>
            </el-col>
            <el-col
              :span="24"
              style="padding: 10px 30px"
              v-if="voteInfo.VoteType === 0 && meetingInfo.MeetingType === 0"
            >
              <div class="table-block">
                <el-table
                  :data="settingForm.VoteButtonSetting"
                  style="width: 100%"
                >
                  <el-table-column
                    label="数值"
                    width="60"
                    align="center"
                    v-if="false"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.key }}
                    </template>
                  </el-table-column>
                  <el-table-column label="按钮文本" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.value }}
                    </template>
                  </el-table-column>
                  <el-table-column label="显示文本" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.showValue }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="是否验证最大最小投票数目"
                    width="170"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.isCheckMaxMin">是</span>
                      <span v-if="!scope.row.isCheckMaxMin">否</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最大投票数"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.maxNum }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最小投票数"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.minNum }}
                    </template>
                  </el-table-column>
                  <el-table-column label="字体颜色" width="120" align="center">
                    <template slot-scope="scope">
                      <span :style="{ color: scope.row.color }">{{
                        scope.row.color
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        @click="handleEdit(scope.$index, scope.row)"
                      >
                        编辑
                      </el-button>
                      <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row)"
                      >
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType === 0 && meetingInfo.MeetingType === 0"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
              v-if="voteInfo.VoteType === 0"
            >
              <el-form-item
                label="默认值/重置默认值："
                label-width="200px"
                prop="ResetDefault"
              >
                <el-select v-model="settingForm.ResetDefault">
                  <el-option
                    v-for="item in settingForm.VoteButtonSetting"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
              v-if="voteInfo.VoteType === 0"
            >
              <el-form-item
                label="是否显示“通过”："
                label-width="200px"
                prop="IsShowPass"
                required
              >
                <el-switch v-model="settingForm.IsShowPass"></el-switch>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType === 0"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="是否显示搜索功能："
                label-width="200px"
                prop="IsShowSearch"
                required
              >
                <el-switch v-model="settingForm.IsShowSearch"></el-switch>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
            >
              <el-form-item
                label="搜索提示语："
                label-width="200px"
                prop="SearchPlaceholder"
                required
              >
                <el-input
                  v-model="settingForm.SearchPlaceholder"
                  autocomplete="off"
                  placeholder="请输入搜索提示语"
                  :disabled="!settingForm.IsShowSearch"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="
              voteInfo.VoteType === 0 &&
              meetingInfo.MeetingType === 0 &&
              !voteInfo.IsScreen
            "
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="是否实时保存结果："
                label-width="200px"
                prop="IsRealTimeSaveResult"
                required
              >
                <el-switch
                  v-model="settingForm.IsRealTimeSaveResult"
                  @change="realTimeSaveResultChange()"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
            >
              <el-form-item
                label="是否纪录投票详细数据："
                label-width="200px"
                prop="IsRecordVoteDetails"
                required
              >
                <el-switch
                  v-model="settingForm.IsRecordVoteDetails"
                  :disabled="!settingForm.IsRealTimeSaveResult"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="
              voteInfo.VoteType === 3 ||
              (voteInfo.VoteType === 0 && voteInfo.IsScreen)
            "
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="打分小数位数："
                label-width="200px"
                prop="ScoringDecimalPlaces"
              >
                <el-input-number
                  v-model="settingForm.ScoringDecimalPlaces"
                  :precision="0"
                  :step="1"
                  :min="0"
                  :max="6"
                ></el-input-number>
                <span class="form_item_info"></span>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="
              voteInfo.VoteType === 3 ||
              (voteInfo.VoteType === 0 && voteInfo.IsScreen)
            "
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="排名显示数量："
                label-width="200px"
                prop="VoteScreenShowNum"
              >
                <el-input-number
                  v-model="settingForm.VoteScreenShowNum"
                  :precision="0"
                  :step="1"
                  :max="10000"
                ></el-input-number>
                <span class="form_item_info">（颁奖页面、分组排名）</span>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
            >
              <el-form-item
                label="名次显示到第几位："
                label-width="200px"
                prop="VoteScreenRankingNum"
                v-show="false"
              >
                <el-input-number
                  v-model="settingForm.VoteScreenRankingNum"
                  :precision="0"
                  :step="1"
                  :max="10000"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType === 3"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 24 }"
              :lg="{ span: 24 }"
              :xl="{ span: 24 }"
              v-for="(
                VoteProjectGroupRankingItem, index
              ) in settingForm.VoteProjectGroupRankingItems"
              :key="index"
            >
              <el-form-item
                :label="
                  VoteProjectGroupRankingItem.ProjectGroupName +
                  '名次显示数量：'
                "
                label-width="200px"
              >
                <el-input-number
                  v-model="VoteProjectGroupRankingItem.RankingNum"
                  :precision="0"
                  :step="1"
                  :max="settingForm.VoteScreenShowNum"
                ></el-input-number>
                <span class="form_item_info">（颁奖页面、分组排名）</span>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType === 3"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="是否显示名次图标："
                label-width="200px"
                prop="IsShowGroupRankingIcon"
              >
                <el-switch
                  v-model="settingForm.IsShowGroupRankingIcon"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType === 3"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="分组名次序号显示类型："
                label-width="200px"
                prop="GroupRankingIndexType"
              >
                <el-select v-model="settingForm.GroupRankingIndexType">
                  <el-option :key="0" label="第{名次序号}名" :value="0">
                  </el-option>
                  <el-option :key="1" label="{名次序号}【同分并列】" :value="1">
                  </el-option>
                  <el-option
                    :key="2"
                    label="{名次序号}【同分按原序号排名】"
                    :value="2"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-show="meetingInfo.MeetingType === 0 && !voteInfo.IsScreen"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
              v-if="voteInfo.VoteType !== 3"
            >
              <!-- <el-form-item label="是否可以查看结果：" label-width="200px">
                <el-switch v-model="settingForm.CanSeeResult"></el-switch>
              </el-form-item> -->
              <el-form-item label="提交后查看结果状态：" label-width="200px">
                <el-select v-model="settingForm.CanSeeResult">
                  <el-option label="提交后不能查看结果" :value="0"> </el-option>
                  <el-option label="提交后可以查看结果" :value="1"> </el-option>
                  <el-option label="提交后不再展示投票" :value="2"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
              v-if="voteInfo.VoteType !== 3 && voteInfo.VoteType !== 5"
            >
              <el-form-item
                label="观察人是否可以查看投票："
                label-width="200px"
              >
                <el-switch v-model="settingForm.IsWatchVote"></el-switch>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
              v-if="voteInfo.VoteType === 3"
            >
              <el-form-item
                label="观察人是否可以查看投票："
                label-width="200px"
              >
                <el-switch v-model="settingForm.IsWatchVote"></el-switch>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-show="voteInfo.VoteType === 1"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
              v-if="voteInfo.VoteType !== 3"
            >
              <el-form-item
                label="输入排序后是否自动移动："
                label-width="200px"
              >
                <el-switch
                  v-model="settingForm.IsSortAutomaticMove"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType === 2"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="投票视图模式："
                label-width="200px"
                prop="VoteViewType"
              >
                <el-select v-model="settingForm.VoteViewType">
                  <el-option
                    key="split_screen"
                    label="分屏显示"
                    value="split_screen"
                  >
                  </el-option>
                  <el-option key="same_page" label="同屏显示" value="same_page">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
              v-if="voteInfo.VoteType === 2"
            >
              <el-form-item label="最少打分项目数量：" label-width="200px">
                <el-input-number
                  v-model="settingForm.ScoringProjectMinNum"
                  :step="1"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType === 2 || voteInfo.VoteType === 3"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="打分投票计算方式："
                label-width="200px"
                prop="WeightedCalculationType"
              >
                <el-select v-model="settingForm.WeightedCalculationType">
                  <el-option
                    key="group_weighted_mean"
                    label="权重分组平均数"
                    value="group_weighted_mean"
                  >
                  </el-option>
                  <el-option
                    key="weighted_mean"
                    label="加权平均数"
                    value="weighted_mean"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            label="投票顶部提示信息："
            label-width="200px"
            v-if="
              (voteInfo.VoteType === 0 || voteInfo.VoteType === 1) &&
              meetingInfo.MeetingType === 0
            "
          >
            <el-input
              v-model="settingForm.VoteMessageConfig"
              autocomplete="off"
              placeholder="请输入提示信息"
            ></el-input>
          </el-form-item>
          <el-divider
            content-position="left"
            v-if="
              voteInfo.VoteType !== 3 &&
              voteInfo.VoteType !== 5 &&
              meetingInfo.MeetingType === 0
            "
            >提交按钮配置</el-divider
          >
          <el-form-item
            label="是否显示："
            label-width="200px"
            v-if="
              voteInfo.VoteType !== 3 &&
              voteInfo.VoteType !== 5 &&
              meetingInfo.MeetingType === 0
            "
          >
            <el-switch
              v-model="settingForm.VoteSubmitConfig.isShow"
            ></el-switch>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="
              voteInfo.VoteType !== 3 &&
              voteInfo.VoteType !== 5 &&
              meetingInfo.MeetingType === 0
            "
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="按钮文本："
                label-width="200px"
                prop="VoteSubmitConfig.textValue"
              >
                <el-input
                  v-model="settingForm.VoteSubmitConfig.textValue"
                  autocomplete="off"
                  placeholder="请输入按钮文本"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
            >
              <el-form-item
                label="提示文本："
                label-width="200px"
                prop="VoteSubmitConfig.value"
              >
                <el-input
                  v-model="settingForm.VoteSubmitConfig.value"
                  autocomplete="off"
                  placeholder="请输入提示文本"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-col
            :span="24"
            v-if="
              voteInfo.VoteType !== 3 &&
              voteInfo.VoteType !== 5 &&
              meetingInfo.MeetingType === 0
            "
          >
            <el-divider content-position="left">重置按钮配置</el-divider>
          </el-col>
          <el-form-item
            label="是否显示："
            label-width="200px"
            v-if="
              voteInfo.VoteType !== 3 &&
              voteInfo.VoteType !== 5 &&
              meetingInfo.MeetingType === 0
            "
          >
            <el-switch v-model="settingForm.VoteResetConfig.isShow"></el-switch>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="
              voteInfo.VoteType !== 3 &&
              voteInfo.VoteType !== 5 &&
              meetingInfo.MeetingType === 0
            "
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="按钮文本："
                label-width="200px"
                prop="VoteResetConfig.textValue"
              >
                <el-input
                  v-model="settingForm.VoteResetConfig.textValue"
                  autocomplete="off"
                  placeholder="请输入按钮文本"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
            >
              <el-form-item
                label="提示文本："
                label-width="200px"
                prop="VoteResetConfig.value"
              >
                <el-input
                  v-model="settingForm.VoteResetConfig.value"
                  autocomplete="off"
                  placeholder="请输入提示文本"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-col
            :span="24"
            v-if="voteInfo.VoteType === 0 && meetingInfo.MeetingType === 0"
          >
            <el-divider content-position="left">全选按钮配置</el-divider>
          </el-col>
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType === 0 && meetingInfo.MeetingType === 0"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item label="是否显示：" label-width="200px">
                <el-switch
                  v-model="settingForm.AllSelectConfig.isShow"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
            >
              <el-form-item
                label="全选值："
                label-width="200px"
                prop="AllSelectConfig.key"
              >
                <!-- <el-input-number
                  v-model="settingForm.AllSelectConfig.key"
                  :step="1"
                ></el-input-number>
                <span style="font-size: 10px">
                  该值匹配“投票按钮配置”中的值
                </span> -->
                <el-select v-model="settingForm.AllSelectConfig.key">
                  <el-option
                    v-for="item in settingForm.VoteButtonSetting"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="voteInfo.VoteType === 0 && meetingInfo.MeetingType === 0"
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="按钮文本："
                label-width="200px"
                prop="AllSelectConfig.allValue"
              >
                <el-input
                  v-model="settingForm.AllSelectConfig.allValue"
                  autocomplete="off"
                  placeholder="请输入按钮文本"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
            >
              <el-form-item
                label="提示文本："
                label-width="200px"
                prop="AllSelectConfig.value"
              >
                <el-input
                  v-model="settingForm.AllSelectConfig.value"
                  autocomplete="off"
                  placeholder="请输入提示文本"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-col
            :span="24"
            v-if="
              voteInfo.VoteType !== 3 &&
              voteInfo.VoteType !== 5 &&
              meetingInfo.MeetingType === 0 &&
              !voteInfo.IsScreen
            "
          >
            <el-divider content-position="left">预览按钮配置</el-divider>
          </el-col>
          <el-form-item
            label="是否显示："
            label-width="200px"
            v-if="
              voteInfo.VoteType !== 3 &&
              voteInfo.VoteType !== 5 &&
              meetingInfo.MeetingType === 0 &&
              !voteInfo.IsScreen
            "
          >
            <el-switch
              v-model="settingForm.VotePreviewConfig.isShow"
            ></el-switch>
          </el-form-item>
          <el-form-item
            class="el-form-item-internal"
            v-if="
              voteInfo.VoteType !== 3 &&
              voteInfo.VoteType !== 5 &&
              meetingInfo.MeetingType === 0 &&
              !voteInfo.IsScreen
            "
          >
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11 }"
              :lg="{ span: 11 }"
              :xl="{ span: 11 }"
            >
              <el-form-item
                label="按钮文本："
                label-width="200px"
                prop="VotePreviewConfig.textValue"
              >
                <el-input
                  v-model="settingForm.VotePreviewConfig.textValue"
                  autocomplete="off"
                  placeholder="请输入按钮文本"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 24 }"
              :md="{ span: 11, offset: 2 }"
              :lg="{ span: 11, offset: 2 }"
              :xl="{ span: 11, offset: 2 }"
            >
              <el-form-item
                label="提示文本："
                label-width="200px"
                prop="VotePreviewConfig.value"
              >
                <el-input
                  v-model="settingForm.VotePreviewConfig.value"
                  autocomplete="off"
                  placeholder="请输入提示文本"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            label="大屏幕背景："
            label-width="200px"
            v-if="voteInfo.VoteType == 3 && meetingInfo.MeetingType === 0"
          >
            <el-image
              :src="settingForm.ScreenBodyBackground"
              lazy
              class="screenBodyBackground"
              :style="{
                height: settingForm.ScreenBodyBackground ? '300px' : '35px'
              }"
            >
              <div slot="error">
                <span>未设置背景图片，将使用默认背景</span>
              </div>
            </el-image>
            <div
              style="
                display: -webkit-flex;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: flex-start;
              "
            >
              <el-button
                size="small"
                type="primary"
                style="margin-right: 10px"
                v-if="settingForm.ScreenBodyBackground"
                @click="deleteScreenBodyBackground()"
              >
                删除图片
              </el-button>
              <el-upload
                class="upload-demo"
                ref="screenBgImageUpload"
                :file-list="voteImageFiles"
                action="#"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :http-request="voteImageHandleUpload"
                :auto-upload="false"
                :multiple="false"
              >
                <el-button size="small" type="primary">
                  <span v-if="!settingForm.ScreenBodyBackground">点击上传</span>
                  <span v-if="settingForm.ScreenBodyBackground">重新上传</span>
                </el-button>
              </el-upload>
            </div>
          </el-form-item>
          <!-- <el-col :span="24">
          <el-divider></el-divider>
        </el-col>
        <el-form-item label-width="200px">
          <el-button type="primary" @click="editVoteSetting('settingForm')">
            保 存
          </el-button>
        </el-form-item> -->
        </el-form>
        <el-dialog
          title="投票按钮配置"
          :visible.sync="dialogFormVisible"
          :close-on-click-modal="false"
          custom-class="custom_dialog"
        >
          <el-form
            :model="btnForm"
            :rules="btnFormRules"
            ref="btnForm"
            label-width="180px"
            class="demo-ruleForm"
            size="mini"
            :label-position="is_xs ? 'top' : 'left'"
          >
            <el-form-item label="数值：" prop="key" v-if="false">
              <el-input-number
                v-model="btnForm.key"
                :step="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="按钮文本：" prop="value">
              <el-input v-model="btnForm.value" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="显示文本：" prop="showValue">
              <el-input
                v-model="btnForm.showValue"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否验证最大最小投票数：" prop="isCheckMaxMin">
              <el-switch v-model="btnForm.isCheckMaxMin"></el-switch>
            </el-form-item>
            <el-form-item
              label="最大投票数："
              prop="maxNum"
              v-if="btnForm.isCheckMaxMin"
            >
              <el-input-number
                v-model="btnForm.maxNum"
                :step="1"
              ></el-input-number>
              <span style="color: red; font-size: 12px; padding-left: 5px">
                评委投票数不能大于{{ btnForm.maxNum }}
              </span>
            </el-form-item>
            <el-form-item
              label="最小投票数："
              prop="minNum"
              v-if="btnForm.isCheckMaxMin"
            >
              <el-input-number
                v-model="btnForm.minNum"
                :step="1"
              ></el-input-number>
              <span style="color: red; font-size: 12px; padding-left: 5px">
                评委投票数不能小于{{ btnForm.minNum }}
              </span>
            </el-form-item>
            <el-form-item label="字体颜色：" prop="color">
              <el-color-picker v-model="btnForm.color"></el-color-picker>
              <br />
              <span>{{ btnForm.color }}</span>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="editBtnConfig('btnForm')">
              确 定
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import voteManageApi from '../../../api/vote/voteManage'
import voteSettingApi from '../../../api/vote/voteSetting'
export default {
  name: 'EditVoteSetting',
  data () {
    return {
      meetingId: null,
      voteId: null,
      loading: true,
      settingForm: {
        VoteButtonSetting: [],
        AllSelectConfig: {},
        VoteSubmitConfig: {},
        VoteResetConfig: {},
        VotePreviewConfig: {}
      },
      settingFormRules: {
        ProjectTitle: [
          { required: true, message: '请输入项目显示名称', trigger: 'blur' },
          { min: 1, max: 50, message: '显示名称长度最多100个字符。', trigger: 'blur' }],
        VoterTitle: [
          { required: true, message: '请输入投票人员显示名称', trigger: 'blur' },
          { min: 1, max: 50, message: '显示名称长度最多100个字符。', trigger: 'blur' }],
        VoteMessageConfig: [
          { min: 0, max: 1000, message: '提示信息长度最多1000个字符。', trigger: 'blur' }],
        ResetDefault: [
          { required: true, message: '请输入投票默认值', trigger: 'blur' }],
        'VoteSubmitConfig.textValue': [
          { required: true, message: '请输入按钮文本', trigger: 'blur' },
          { min: 1, max: 10, message: '按钮文本长度最多10个字符。', trigger: 'blur' }],
        'VoteSubmitConfig.value': [
          { required: true, message: '请输入提示文本', trigger: 'blur' },
          { min: 1, max: 10, message: '提示文本长度最多10个字符。', trigger: 'blur' }],
        'VoteResetConfig.textValue': [
          { required: true, message: '请输入按钮文本', trigger: 'blur' },
          { min: 1, max: 10, message: '按钮文本长度最多10个字符。', trigger: 'blur' }],
        'VoteResetConfig.value': [
          { required: true, message: '请输入提示文本', trigger: 'blur' },
          { min: 1, max: 10, message: '提示文本长度最多10个字符。', trigger: 'blur' }],
        'AllSelectConfig.allValue': [
          { required: true, message: '请输入按钮文本', trigger: 'blur' },
          { min: 1, max: 10, message: '按钮文本长度最多10个字符。', trigger: 'blur' }],
        'AllSelectConfig.value': [
          { required: true, message: '请输入提示文本', trigger: 'blur' },
          { min: 1, max: 10, message: '提示文本长度最多10个字符。', trigger: 'blur' }],
        'AllSelectConfig.key': [
          { required: true, message: '请输入全选值', trigger: 'blur' }]
      },
      dialogFormVisible: false,
      btnForm: {},
      editIndex: null,
      btnFormRules: {
        key: [
          { required: true, message: '请输入数值', trigger: 'blur' }],
        value: [
          { required: true, message: '请输入按钮文本', trigger: 'blur' },
          { min: 1, max: 10, message: '按钮文本长度最多10个字符。', trigger: 'blur' }],
        showValue: [
          { required: true, message: '请输入显示文本', trigger: 'blur' },
          { min: 1, max: 10, message: '显示文本长度最多10个字符。', trigger: 'blur' }],
        maxNum: [
          { required: true, message: '请输入最大投票数', trigger: 'blur' }],
        minNum: [
          { required: true, message: '请输入最小投票数', trigger: 'blur' }],
        color: [
          { required: true, message: '请输入字体颜色', trigger: 'blur' }]
      },
      voteInfo: {
        Status: null
      },
      projectTitles: [
        { value: '项目数' },
        { value: '表决数' },
        { value: '表决项' },
        { value: '候选人' },
        { value: '议程数' },
        { value: '评测对象' },
        { value: '被考核人' },
        { value: '被测评人' }],
      voterTitles: [
        { value: '评委数' },
        { value: '代表数' },
        { value: '评测人' },
        { value: '考核人' },
        { value: '投票人' }],
      voteImageFiles: [],
      isDeleteScreenBodyBackground: false
    }
  },
  props: ['meetingInfo'],
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    getVoteInfo: function () {
      this.loading = true
      if (this.$route.params.vid !== '0') {
        voteManageApi.getVoteDetail({
          voteId: this.$route.params.vid
        }).then(data => {
          this.voteInfo = data
          this.getVoteSetting()
        }).catch(err => {
          this.loading = false
          return err
        })
      } else {
        this.voteInfo.Status = 0
        this.loading = false
      }
    },
    getVoteSetting: function () {
      const _this = this
      _this.loading = true
      voteSettingApi.getVoteSetting({ voteId: _this.voteId }).then(data => {
        _this.settingForm = data
        _this.settingForm.ResetDefault = _this.settingForm.ResetDefault + ''
        _this.loading = false
      }).catch(err => {
        _this.loading = false
        return err
      })
    },
    editVoteSetting: function (formName, isFinish) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          voteSettingApi.editVoteSetting(this.settingForm).then(data => {
            this.getVoteSetting()
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            if (isFinish) {
              this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
            }
          }).catch(err => {
            this.loading = false
            return err
          })
        } else {
          return false
        }
      })
    },
    voteImageHandleUpload: function (raw) {
      const _this = this
      _this.voteImageFiles.push(raw.file)
    },
    deleteScreenBodyBackground: function (raw) {
      const _this = this
      _this.isDeleteScreenBodyBackground = true
      _this.settingForm.ScreenBodyBackground = ''
    },
    editVoteSettingAndUpload: function (formName) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.loading = true
          _this.$refs.screenBgImageUpload.submit()
          const fd = new FormData()
          fd.append('VoteSetting', JSON.stringify(_this.settingForm))
          fd.append('IsDeleteImage', _this.isDeleteScreenBodyBackground)
          _this.voteImageFiles.forEach(function (file, index) {
            fd.append('voteFiles' + index, file)
          })

          voteSettingApi.editVoteSettingAndUpload(fd).then(data => {
            _this.getVoteSetting()
            _this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            _this.voteImageFiles = []
          }).catch(err => {
            _this.loading = false
            return err
          })
        } else {
          return false
        }
      })
    },
    handleEdit: function (index, row) {
      this.btnForm = JSON.parse(JSON.stringify(row))
      this.editIndex = index
      this.dialogFormVisible = true
    },
    handleDelete: function (index, row) {
      const _this = this
      _this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        _this.loading = true
        _this.settingForm.VoteButtonSetting.splice(index, 1)
        _this.settingForm.VoteButtonSetting.forEach((item, index) => {
          item.key = index
        })
        _this.$message({
          type: 'success',
          message: '删除成功!',
          customClass: 'custom_message'
        })
        _this.loading = false
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    addBtn: function () {
      this.btnForm = {}
      this.btnForm.key = this.settingForm.VoteButtonSetting.length
      this.editIndex = null
      this.dialogFormVisible = true
    },
    editBtnConfig: function (formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.loading = true
          if (_this.editIndex != null) {
            this.settingForm.VoteButtonSetting.splice(_this.editIndex, 1, JSON.parse(JSON.stringify(_this.btnForm)))
          } else {
            _this.settingForm.VoteButtonSetting.push(JSON.parse(JSON.stringify(_this.btnForm)))
          }
          _this.editVoteSetting('settingForm', false)
          this.dialogFormVisible = false
        } else {
          return false
        }
      })
    },
    queryProjectTitleSearch (queryString, cb) {
      cb(this.projectTitles)
    },
    projectTitleHandleSelect (item) {
      // console.log(this.settingForm.ProjectTitle)
    },
    queryVoterTitleSearch (queryString, cb) {
      cb(this.voterTitles)
    },
    voterTitleHandleSelect (item) {
      // console.log(this.settingForm.ProjectTitle)
    },
    realTimeSaveResultChange: function () {
      const _this = this
      if (!_this.settingForm.IsRealTimeSaveResult) {
        _this.settingForm.IsRecordVoteDetails = true
      }
    }
  },
  created () {
    this.voteId = this.$route.params.vid
    this.getVoteInfo()
  }
}
</script>
<style lang="less">
.el-divider--horizontal {
  margin: 15px 0px;
}
.screenBodyBackground {
  border-radius: 4px;
}
</style>
